// #region imports

// --- Angular
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';

// --- RxJs
import { BehaviorSubject, fromEvent, Subscription } from 'rxjs';

// --- 3rd Party

// --- HS Code

// #endregion

@Component({
  selector: 'hs-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements AfterViewInit, OnDestroy {

  @Input() videoUrl: string = '';
  @Input() thumbnail: string = '';

  @ViewChild('videoPlayer', {static: true}) videoPlayer: ElementRef<HTMLVideoElement> | undefined;
  @ViewChild('videoPlayButton', {static: true}) videoPlayButton: ElementRef<HTMLDivElement> | undefined;

  showControls$: BehaviorSubject<boolean>;

  get thumbnailOnly(): boolean {
    return !this.videoUrl;
  }

  private _playSubscription: Subscription = Subscription.EMPTY;

  constructor() {
    this.showControls$ = new BehaviorSubject<boolean>(false);
  }

  ngAfterViewInit(): void {
    const video = this.videoPlayer?.nativeElement;
    const videoPlayButton = this.videoPlayButton?.nativeElement;

    if (!videoPlayButton || !video) return;

    this._playSubscription = fromEvent(videoPlayButton, 'click')
      .subscribe(() => {
        video.play();
        this.showControls$.next(true);
    });
  }

  ngOnDestroy(): void {
    if (this._playSubscription) {
      this._playSubscription.unsubscribe();
      this._playSubscription = Subscription.EMPTY;
    }
  }
}
